<template>
  <div>
    <!-- <div class="flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Games</h2>
    </div> -->
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <div class="intro-y col-span-12">
        <div class="grid grid-cols-12 gap-5 mt-5 pt-5 border-t border-theme-5">
          <a
            href="javascript:;"
            class="intro-y block col-span-12 sm:col-span-4 xxl:col-span-3"
            @click="enterGame(44)"
          >
            <div class="box rounded-md p-3 relative zoom-in">
              <div class="flex-none relative block">
                <div class="pos-image__preview ">
                  <img
                    alt="Midone Tailwind HTML Admin Template"
                    src="@/assets/images/sa.jpg"
                  />
                </div>
              </div>
              <div class="block font-medium text-center truncate mt-3">SA GAMING</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Toastify from "toastify-js";
export default {
  data() {
    return {
      games: [
        {prd_id: 2, name: "Big Gaming"},
        {prd_id: 3, name: "Micro Gaming Live"},
        {prd_id: 5, name: "Asia Gaming"},
        {prd_id: 6, name: "Dream Gaming"},
        {prd_id: 9, name: "Sexy Gaming"},
        {prd_id: 11, name: "Live 88"},
        {prd_id:12, name: "Playtech Live"},
        {prd_id: 17, name: "Ezugi"},
        {prd_id: 19, name: "Skywind Live" },
        {prd_id: 33, name: "Evolution ROW"},
        {prd_id: 36, name: "Pragmatic Play Live [EU]"},
        {prd_id: 100, name: "Illustrate Analytics"},
        {prd_id: 105, name: "BTI Sports"},
        {prd_id: 201, name: "Habanero"},
        {prd_id: 204, name: "Quickspin"},
        {prd_id: 205, name: "Spade Gaming"},
        {prd_id: 207, name: "Play'N Go"},
        {prd_id: 208, name: "World Match"},
        {prd_id: 209, name: "Micro Gaming Slot"},
        {prd_id: 211, name: "OneTouch"},
        {prd_id: 216, name: "YGGDrasil"},
        {prd_id: 217, name: "BNG"},
        {prd_id: 218, name: "Playson"},
        {prd_id: 219, name: "Playtech Slot"},
        {prd_id: 221, name: "Skywind Slot"},
        {prd_id: 223, name: "PG Soft"},
        {prd_id: 229, name: "Relax Gaming"},
        {prd_id: 231, name: "NextSpin"},
        {prd_id: 232, name: "Spinix"},
        {prd_id: 255, name: "Hacksaw Gaming"},
        {prd_id: 259, name: "Red Tiger Row"},
        {prd_id: 260, name: "Netent ROW"},
        {prd_id: 261, name: "Big Time Gaming ROW"},
        {prd_id: 262, name: "No Limit City ROW"},
        {prd_id: 270, name: "Pragmatic Play Slots [EU]"},
        {prd_id: 271, name: "Booming Games"},
        {prd_id: 276, name: "Evoplay"},
        {prd_id: 300, name: "Spribe"},
        {prd_id: 302, name: "Alize"},
        {prd_id: 303, name: "Aviatrix"},
        {prd_id: 304, name: "Fast Game"},
      ],
    };
  },
  mounted() {
    // 页面加载时调用
    // this.getGames();

    // 如果页面加载时是可见的，立即获取余额
    if (document.visibilityState === "visible") {
      this.getBalance();
    }

    // 监听页面可见性变化
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    // 移除事件监听器，防止内存泄漏
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  methods: {
    getGames() {
      let self = this;
      axios
        .get("/api/game/new_evo_games", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })
        .then((res) => {
            console.log(res)
          //self.games = res.data.data.simpleGameList;
        })
        .catch(function (error) {
          self.handleError(error);
        });
    },

    enterGame(gameId) {
      let self = this;
        axios
            .post("/api/game/getNewEvoGame", {
              gameId: gameId
            }, {
            headers:{
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
            })
            .then((res) => {
              window.open(res.data.link, '_blank');
            })
            .catch(function (error) {
              self.handleError(error);
            });
    },

    getBalance() {
      let self = this;
        axios
          .get("/api/game/getUser", {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          })
          .then((res) => {
            if (res.data.status == "error") {
              self.handleError(res);
            } else {
              self.$store.dispatch("main/setUser", res.data.user);
            }
          })
          .catch(function (error) {
            self.handleError(error);
          });
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        // 页面可见时调用 getBalance 方法
        this.getBalance();
      }
    },
    handleError(res) {
      if (
        (res.data?.status == "error" && res.data?.message == "Token expired") ||
        res.response?.status == 401
      ) {
        this.$store.dispatch("main/logout").then((res) => {
          this.$router.push({ path: "/" });
        });
      }
    }
  },
};
</script>

<style scoped>
  .pos .pos-image:before {
    padding-top: 57%;
  }
</style>
